import clsx from "clsx";
import type { ButtonHTMLAttributes, PropsWithChildren, ReactNode } from "react";

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  variant?: "primary" | "secondary" | "ghost" | "danger";
}

export function ActionButton({
  children,
  className,
  icon,
  variant = "secondary",
  ...props
}: PropsWithChildren<ActionButtonProps>) {
  return (
    <button className={clsx("action-button", `action-button--${variant}`, className)} {...props}>
      {icon ? <span className="action-button__icon">{icon}</span> : null}
      <span>{children}</span>
    </button>
  );
}
